<template>
  <div
    :style="{
        width: '100%',
        backgroundColor: currentPageConfig?.info?.backgroundColor,
        backgroundImage: currentPageConfig?.info?.backgroundImage
          ? `url(${currentPageConfig.info.backgroundImage})`
          : ''
      }"
    class="page-wrap"
  >
    <div v-if="currentPageConfig">
     
      <div v-for="(item, idx) in currentPageConfig.elements" :key="idx">
        <element-item
          :disabled="!edit"
          :item-data="item"
          :idx="idx"
          :allArcListMap="allArcListMap"
          :parent-keys="[...parentKeys, idx]"
          :list-length="currentPageConfig.elements.length"
          :current-element-index="currentElementIndex"
          :current="idx + '' === currentElementIndexStr"
          :pages="pages"
        ></element-item>
      </div>
    </div>
  </div>
</template>
  <script setup>
import { ref, computed, watch, inject, provide } from "vue"; 
import { get } from "lodash-es"; 

// Props
const props = defineProps({
  allArcListMap: {
    type: Object,
    default: () => ({})
  },
  currentElementIndex: {
    type: Array,
    default: () => []
  },
  idx: {
    type: Number,
    default: -1
  },
  parentKeys: {
    type: Array,
    default: () => []
  },
  disabled: {
    type: Boolean,
    default: true
  },
  config: {
    type: Object
  }
});

// Reactive State
const edit = ref(false);

// Computed Properties
const currentElementIndexStr = computed(() => {
  return props.currentElementIndex && props.currentElementIndex.length
    ? props.currentElementIndex.join("x")
    : "";
});

const pages = computed(() => {
  let res = [];
  try {
    res = JSON.parse(props.config.configData);
  } catch (e) {
    console.error("解析内容失败", e);
  }
  return res;
});

const currentPageConfig = computed(() => {
  return pages.value && pages.value[0] ? pages.value[0] : null;
});

const parentGetConfigJson = inject("getConfigJson", () => ({}));

function getComponentConfigJsonHook() {
  const parentConfig =
    typeof parentGetConfigJson === "function" ? parentGetConfigJson() : {};

  return {
    langJson: {
      ...(parentConfig?.langJson || {}),
      ...(currentPageConfig.value?.langJson || {}),
    },
    bindData: {
      ...(parentConfig?.bindData || {}),
      ...(currentPageConfig.value?.bindData || {}),
    },
  };
}

provide("getConfigJson", getComponentConfigJsonHook);

function setPageAppend() {
  if (currentPageConfig.value) {
    if (get(currentPageConfig.value, "info.cssText", "")) {
      useHead({
        style: [
          {
            body: true,
            innerHTML: get(currentPageConfig.value, "info.cssText", "")
          }
        ]
      });
    }
    if (
      process.client &&
      get(currentPageConfig.value, "info.javascriptText", "")
    ) {
      useHead({
        script: [
          {
            type: "text/javascript",

            body: true,
            innerHTML: get(currentPageConfig.value, "info.javascriptText", "")
          }
        ]
      });
    }
  }
}

setPageAppend();
 
watch(
  () => props.config,
  value => {
    // Handle config updates here
    setPageAppend();
  },
  { deep: true, immediate: true }
);
</script>
